/**
 * Copyright 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Modal } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { SERVICENOW_MSG_PREVIEW_MODAL_TITLE } from "../../constants";
import { KpiPreviewMessage } from "../../PreviewMessages";
import { KpiOptionsDataTypeField } from "./KpiOptionsDataTypeField";
import { ShortDescriptionField } from "./ShortDescriptionField";

type Props = {
  isReadMode: boolean;
};

export function KpiOptionsSection({ isReadMode }: Props) {
  const { isOpen, close, open } = useDisclosure();

  return (
    <>
      <ShortDescriptionField isReadMode={isReadMode} />
      <KpiOptionsDataTypeField
        isReadMode={isReadMode}
        onPreviewClick={() => open()}
      />
      <Modal
        isOpen={isOpen}
        actions={[]}
        contentMaxHeight="40rem"
        contentLabel={SERVICENOW_MSG_PREVIEW_MODAL_TITLE}
        onClose={() => close()}
      >
        <KpiPreviewMessage />
      </Modal>
    </>
  );
}
